import React from 'react';
import ContentSlider from '../../../components/content-slider';
import CustomImage from '../../../components/custom-image';
import FatehsagarLake from '../../../content/social-development/casestudy-2/image1';
import Collapse from '../../../components/collapse';
import ScrollPositionAnimation from '../../../components/scrollpositionanimation';

const Casestudy2 = () => {
  const slider = {
    slides: [
      <div className="case-study-slider">
        <CustomImage
          className="custom-image"
          imageName="fatehsagar-lake.jpg"
          alt="Fateh sagar lake"
          maxWidth="768"
        />
      </div>,
      <div className="case-study-slider">
        <CustomImage
          className="custom-image"
          imageName="fatehsagar-lake1.jpg"
          alt="Fateh sagar lake"
          maxWidth="768"
        />
      </div>
    ],
  };
  return (
    <div className="container-fluid">
      <div className="social-development-container bottom-section">
        <ScrollPositionAnimation targetElement1="anim-eight" targetElement2="anim-nine">
          <div className="section-inner other-section">
            <div className="left-content p-t-0">
              <div className="bottom-to-top anim-nine">
                <p className="small-text">CASE STUDY 02:</p>
                <h3 className="bold-text blue-text text-width">BEYOND THE FENCE - POND DEEPENING PROJECT</h3>
                <div className="mobile-img mobile-slider">
                    <ContentSlider data={slider.slides} 
                      slidesToShow={1} 
                      slidesToScroll={1} 
                      customClass="blue-dots-slider" 
                      dots={true} />
                </div>
                <p>
                  HZL has spearheaded significant work on water preservation, considering that its operations are located in the water
                  stressed state of Rajasthan. In addition to the work done to reduce the dependence of its operating sites on local water
                  bodies, HZL has also instituted water management projects in its local communities.
                </p>
                <h6>Fateh Sagar Lake Deepening Project at Udaipur</h6>
                <p>
                  Vedanta, in association with the Urban Development Trust (UIT) of Udaipur has taken up the Fateh Sagar Lake deepening initiative, by desilting the
                  lake during dry periods. 
                </p>

                <Collapse labelOne="Read More" labelTwo="Read Less">
                  <p>The desilting process has deepened the lake by increasing the catchment area and allowing trapping of more water in the rainy season, helping
                    preserve water longer in those years with weak monsoons. 
                  </p>
                  <p>
                    This project aims at improvement of lake biodiversity and creates a safe place for migratory birds.
                  </p>
                </Collapse>
                
                <div className="blue-box">
                  <p><strong>SDG Alignment</strong></p>
                  <ul>
                    <li><span>Goal: SDG 6-</span> Clean Water and Sanitation</li>
                    <li><span>Target:</span> 6.6. Protect and restore water-related eco-systems</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="right-img">
              <div className="right-to-left anim-eight">
                <div className="desktop-img">
                    <ContentSlider data={slider.slides} 
                      slidesToShow={1} 
                      slidesToScroll={1} 
                      customClass="blue-dots-slider" 
                      dots={true} />
                </div>
              </div>
            </div>
          </div>
        </ScrollPositionAnimation>
      </div>
    </div>
  );
};

export default Casestudy2;
